export interface ConversionResult {
  blob: Blob;
  fileName: string;
  format: string;
  size: number;
}
export async function convertToMp3(audioBlob: Blob): Promise<ConversionResult> {
  try {
    const mp3Blob = new Blob([audioBlob], { type: 'audio/mp3' });
    const fileName = `recording_${Date.now()}.mp3`;
    
    return {
      blob: mp3Blob,
      fileName,
      format: 'audio/mp3',
      size: mp3Blob.size
    };
  } catch (error) {
    console.error('MP3 format conversion failed:', error);
    return {
      blob: audioBlob,
      fileName: `recording_${Date.now()}.mp3`,
      format: 'audio/mp3',
      size: audioBlob.size
    };
  }
}

export function getBestSupportedMimeType(): string {
  const mimeTypes = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/ogg',
    'audio/wav'
  ];

  for (const mimeType of mimeTypes) {
    if (MediaRecorder.isTypeSupported?.(mimeType)) {
      return mimeType;
    }
  }

  return 'audio/webm';
}
